import { useEffect, useContext, useCallback } from "react";

import StepsPagination from "../Content/StepsPagination";
import StepsHeadline from "../Content/StepsHeadline";
import StepsForm from "../Content/StepsForm";
import RadioCard from "../Content/RadioCard";

import CalculatorContext from "../../Context/CalculatorContext";

import iconYes from "../../Images/static/icons/icon-yes.svg";
import iconNo from "../../Images/static/icons/icon-no.svg";
import HelperText from "../Content/HelperText";

/* eslint-disable max-len */
function StepSevenPage() {
  const { setCurrentStepIndex, isEnergyImprovementPossible, setIsEnergyImprovementPossible } =
    useContext(CalculatorContext);

  useEffect(() => {
    setCurrentStepIndex(6);
  }, [setCurrentStepIndex]);

  const onIsEnergyImprovementPossibleChange = useCallback(
    (e) => {
      setIsEnergyImprovementPossible(e.target.value);
    },
    [setIsEnergyImprovementPossible],
  );

  return (
    <div className="tx-kalo form-steps-abwizard form-steps-abwizard-transparent">
      <div className="frame frame-size-default frame-full frame-background-tertiary">
        <div className="frame-group-container">
          <div className="frame-container frame-container-default">
            <div className="frame-inner frame-inner-space-before-extra-small frame-inner-space-after-medium">
              <StepsPagination />

              <StepsHeadline>
                <h4 className="element-header text-center">
                  Verhindern öffentlich-rechtliche Vorgaben die energetische Verbesserung der{" "}
                  <span className="text-primary">Gebäudehülle</span>?
                </h4>
              </StepsHeadline>

              <div className="frame frame-size-default frame-indent-8 frame-space-after-extra-small">
                <div className="frame-container frame-container-default">
                  <div className="frame-inner">
                    <div className="tx-powermail">
                      <div className="wrap-fluid">
                        <StepsForm>
                          <fieldset className="powermail_fieldset">
                            <div className="row justify-content-center">
                              <div className="col-md-9 col-lg-8 text-center">
                                <fieldset className="form-group">
                                  <div className="form-group">
                                    <div className="form-group-custom-radio">
                                      <RadioCard
                                        id="is_energy_improvement_possible_1"
                                        image={iconYes}
                                        label="Ja"
                                        // value="1"
                                        value="0"
                                        // checked={isEnergyImprovementPossible === "1"}
                                        checked={isEnergyImprovementPossible === "0"}
                                        onChange={onIsEnergyImprovementPossibleChange}
                                      />

                                      <RadioCard
                                        id="is_energy_improvement_possible_0"
                                        image={iconNo}
                                        label="Nein"
                                        // value="0"
                                        value="1"
                                        // checked={isEnergyImprovementPossible === "0"}
                                        checked={isEnergyImprovementPossible === "1"}
                                        onChange={onIsEnergyImprovementPossibleChange}
                                      />
                                    </div>
                                  </div>
                                </fieldset>

                                <div className="form-group pt-4 pt-md-3">
                                  <input
                                    className="btn btn-secondary"
                                    type="submit"
                                    value="Weiter"
                                    disabled={isEnergyImprovementPossible === ""}
                                  />
                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </StepsForm>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <HelperText>
                <p>
                  Sofern öffentlich-rechtliche Vorgaben einer wesentlichen Verbesserung der
                  Gebäudehülle entgegenstehen, kreuzen Sie hier bitte „Ja“ an.
                </p>
                <p>&nbsp;</p>

                <p className="mb-3">Zu den Vorgaben zählen beispielsweise:</p>

                <ul className="text-start list-chevron">
                  <li>denkmalschutzrechtliche Beschränkungen</li>
                  <li>
                    rechtliche Verpflichtungen, Wärmelieferungen in Anspruch zu nehmen, insbesondere
                    bei einem Anschluss- und Benutzungszwang{" "}
                  </li>
                  <li>
                    das Gebäude liegt im Geltungsbereich einer Erhaltungssatzung gemäß § 172 Absatz
                    1 Nr 2 des Baugesetzbuchs.
                  </li>
                </ul>
              </HelperText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepSevenPage;
